import React from 'react';
import { FieldLabel } from '@measured/puck';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import CustomTooltip from '../../../components/common/tooltip';
import ColorPicker from '../../puck/reusable-props/ColorPicker';

const options = [
  {
    label: 'Mobile',
    value: 'mobile',
  },
  {
    label: 'Tablet',
    value: 'tablet',
  },
  {
    label: 'Desktop',
    value: 'desktop',
  },
];

const options2 = [
  { label: 'Cart', value: 'cart' },
  { label: 'Secure Connection', value: 'secure' },
  { label: 'Off', value: '' },
];

interface Show {
  device: string;
  cartColor: string;
  show: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
}

interface ShowLogoProps {
  onChange: (_value: Show) => void;
  value: Show;
}

const ShowLogo = ({ onChange, value }: ShowLogoProps) => {
  return (
    <>
      <FieldLabel
        label={
          (
            <CustomTooltip title="device">
              <span>Device</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }
        el="div">
        <ToggleButtonGroup
          value={value?.device}
          exclusive
          className="w-full"
          onChange={(_e, selectValue) =>
            onChange({ ...value, device: selectValue })
          }
          aria-label="device">
          {options.map((option, index: number) => (
            <ToggleButton
              key={index}
              size="small"
              value={option.value}
              disableRipple
              aria-label={option.value}
              className="flex-1">
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </FieldLabel>
      <FieldLabel
        label={
          (
            <CustomTooltip title="device">
              <span>Show</span>
            </CustomTooltip>
          ) as React.ReactNode as string
        }
        el="div"
        className="mt-2">
        <ToggleButtonGroup
          value={value?.show?.[value?.device] as string}
          exclusive
          className="w-full"
          onChange={(_e, selectValue) =>
            onChange({
              ...value,
              show: { ...value.show, [value?.device]: selectValue },
            })
          }
          aria-label="show">
          {options2.map((option, index: number) => (
            <ToggleButton
              key={index}
              size="small"
              value={option.value}
              disableRipple
              aria-label={option.value}
              className="flex-1">
              {option.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </FieldLabel>
      {value?.show?.[value?.device] === 'cart' && (
        <div className="mt-2">
          <ColorPicker
            value={value.cartColor}
            onChange={(color: string) =>
              onChange({ ...value, cartColor: color })
            }
            label="Cart Color"
            tooltip="This property will define the color of the cart in the Simple header."
          />
        </div>
      )}
    </>
  );
};

export default ShowLogo;
